"use client";
import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onChange: () => void): () => void {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

const read = () => window.matchMedia(QUERY).matches;
// Server assumes motion is allowed; the client corrects on hydration.
const readServer = () => false;

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, read, readServer);
}
